const ventilations = [
    { name: 'Ducoton 10ZR 9001', height_correction: 80 },
    { name: 'Ducoton 10ZR Blank al.', height_correction: 80 },
    { name: 'Ducoton 10ZR 9010', height_correction: 80 },
    { name: 'Duco Smart 9001', height_correction: 60 },
    { name: 'Duco Smart Blank al.', height_correction: 60 },
    { name: 'Duco Smart 9010', height_correction: 60 }
];

export default ventilations


// WEBPACK FOOTER //
// ./src/data/ventilations.js